import React from 'react';
// import A from '../A';
import './Whoinfo.css';
import {
  capitalizeFirstLetter,
  isMobilePhone,
} from '../../library/calc';
import {
 fontFamily,
 borderColor,
} from '../../library/constants';

import { truncate, } from 'lodash';

export default ({ obj, nodeForFlipFocus, nodeObjs, flipData, fetchIsLoading}) => {

  // console.log(`flipData: `, JSON.stringify(flipData, null, 2));

  const width = 190;
  const styleObjSpecific = ( isMobilePhone() ?

    {
      fontSize: '18px',
    }

  :

    {
      position: 'relative',
      float: 'left',
      width: `${width}px`,
      height: `${123}px`,
      fontSize: '22px',
      overflow: 'auto',
    }


  )

  let styleObj = {
    ...styleObjSpecific,
    left: '25px',
    fontFamily: `${fontFamily}`,
    // border: '1px solid gray'
  }

  if(typeof(flipData) === 'undefined' || flipData === null || fetchIsLoading) {

    styleObj = {
      ...styleObj,
      height: '20px',
      width: `${(width - 30)}px`,
      marginTop:' 7px',
      background: borderColor,
      opacity: .6,
    }

    return (
      <div>
        <div style={styleObj}>
        </div>
        <div style={styleObj}>
        </div>
        <div style={styleObj}>
        </div>
      </div>
    )
  }

  if( nodeForFlipFocus === null ||
      typeof(nodeObjs[nodeForFlipFocus]) === 'undefined'){
    return null;
  }

  const nodeObj = nodeObjs[nodeForFlipFocus];
  const prId = nodeObj.pr_id;
  const href = '/profile/index/' + prId;
  let name = flipData.attrs.long_name;
  name = truncate(name, {
      length: 100,
      separator: ' '
  })

  return (
      <div id="whoinfo-div" style={styleObj}>

        <a
          target="_blank"
          rel="noopener noreferrer"
          className="alink"
          href={href}
          dangerouslySetInnerHTML={{__html: name}}
        />


        <div style={{
          fontSize: '13px',
          fontFamily: `${fontFamily}`,
        }}>
          {

            typeof(flipData.attrs.relationship_string) !== 'undefined'

            ?

            (capitalizeFirstLetter(flipData.attrs.relationship_string))

            :

            ''
          }
        </div>
      </div>
  )
};

